import script from "./SvgSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgSuccess.vue?vue&type=script&setup=true&lang=js"

import "./SvgSuccess.vue?vue&type=style&index=0&id=55664538&scoped=true&lang=css"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55664538"]])

export default __exports__